export function base64ToBlob(base64, mime) {
  mime = mime || "";
  var sliceSize = 1024;
  var byteChars = window.atob(base64);
  var byteArrays = [];

  for (
    var offset = 0, len = byteChars.length;
    offset < len;
    offset += sliceSize
  ) {
    var slice = byteChars.slice(offset, offset + sliceSize);

    var byteNumbers = new Array(slice.length);
    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    var byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }
  return new Blob(byteArrays, { type: mime });
}

// Allowed upload types (S3DEV2-7865). The server is the real control: keep these in sync with
// Phoenix_Back_End Helper/FileTypePolicy.cs (AllowedExtensions / AllowedPhotoExtensions).
export const IMAGE_UPLOAD_ACCEPT = ".jpg,.jpeg,.png,.gif,.bmp,.tif,.tiff,.webp";

export const DOCUMENT_UPLOAD_ACCEPT = [
  ".pdf",
  IMAGE_UPLOAD_ACCEPT,
  ".doc,.docx,.xls,.xlsx,.ppt,.pptx,.odt,.ods,.odp",
  ".csv,.txt,.rtf,.mp3"
].join(",");

// Lowercase extension with its dot (".pdf"), or "" when the name has none.
export const getFileExtension = fileName => {
  const name = String(fileName || "");
  const lastDot = name.lastIndexOf(".");
  return lastDot < 0 ? "" : name.slice(lastDot).toLowerCase();
};

// Client-side check against an accept list (for example DOCUMENT_UPLOAD_ACCEPT). It only gives
// the user an early message; the server check is the control.
export const isAllowedUploadFile = (fileName, accept) =>
  accept.split(",").includes(getFileExtension(fileName));

export const fileTypeNotAllowedMessage = accept =>
  `This file type is not supported. Allowed types: ${accept.split(",").join(", ")}.`;
